var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.278 34.344h37.443V7.742H5.278v26.602zm39.428 1.984V5.758H3.294v30.57h19.714v3.93H8.266v1.984h31.463v-1.984H24.992v-3.93h19.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.826 31.694h11.777v-1.843H8.826zM8.826 28.259h11.777v-1.843H8.826zM14.715 22.17c-2.424 0-4.44-1.747-4.874-4.046h5.795v-5.796a4.969 4.969 0 0 1 4.047 4.874 4.974 4.974 0 0 1-4.968 4.968m-.921-9.842v3.953H9.84a4.968 4.968 0 0 1 3.953-3.953m.92-1.936a6.818 6.818 0 0 0-6.81 6.81 6.818 6.818 0 0 0 6.81 6.81 6.818 6.818 0 0 0 6.81-6.81 6.818 6.818 0 0 0-6.81-6.81M37.476 31.538h1.842V12.033h-1.842zM24.034 31.538h1.842v-6.736h-1.842zM28.515 31.538h1.842V16.352h-1.842zM32.995 31.538h1.842V20.652h-1.842z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard-2.4c0ee5c3ea8e8e207a2ec9bc1c67ff0d.svg";
export { ForwardRef as ReactComponent };